// 平板车位锁
export const device = {
  path: '/main/device',
  name: '平板车位锁',
  component: () => import('@/page/commons/routeTemp.vue'),
  children: [
    {
      path: 'data-overview',
      name: '数据概览',
      component: () => import('@/page/device/data-overview/data-overview.vue'),
      meta: {
        requireAuth: true,
        title: '数据概览'
      }
    },
    // {
    //   path: 'lock-management',
    //   name: '平板车位锁管理',
    //   component: () => import('@/page/device-flat-parking-lock/lock-management/lock-management.vue'),
    //   meta: {
    //     requireAuth: true,
    //     title: '平板车位锁管理'
    //   }
    // },
   
  
   
    
    
  ]
};
